export const vandijk = {
    logo: {
        path: 'clients/van-dijk-logo-white.svg',
        alt: 'Lely international',
    },
};
